import {
  Component,
  Signal,
  computed,
  effect,
  inject,
  input,
} from "@angular/core";
import { NbAccordionModule } from "@nebular/theme";
import { FaqService } from "app/@core/services/faq.service";
import { Course, Faq, FaqFilter, User } from "app/@core/types";

@Component({
  standalone: true,
  selector: "ngx-course-faq",
  styleUrls: ["./faq.component.scss"],
  templateUrl: "./faq.component.html",
  imports: [NbAccordionModule],
  providers: [{ provide: FaqService, useClass: FaqService }],
})
export class FaqComponent {
  private faqService = inject(FaqService);

  course = input.required<Course>();
  filter = input<FaqFilter>({ key: "default", value: "", limit: 5 });

  user: User;
  faqs: Signal<Faq[]>;
  faq: Faq;
  limit: number = 10;

  constructor() {
    effect(() => {
      const course = this.course();
      if (course.id !== 0) this.faqService.loadCourseFaq(this.course().id);
    });
  }

  filteredFaqs = computed(() => {
    const faqs = this.faqService.faqs();
    if (!faqs) return [];
    switch (this.filter().key) {
      case "limit":
        return faqs.slice(0, this.filter().value);
      case "module":
        return faqs.filter((f) => f.module_id === this.filter().value);
      case "lesson":
        return faqs.filter((f) => f.lesson_id === this.filter().value);
      case "user":
        return faqs.filter((f) => f.user_id === this.filter().value);
      default:
        return this.faqService.faqs();
    }
  });

  total = computed(() => {
    return this.filteredFaqs().length ?? 0;
  });

  loadMore(limit: number) {
    this.limit = limit;
  }
}
